import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MaincontentComponent } from './maincontent/maincontent.component';
import { AboutComponent } from './about/about.component';
import { ContactComponent } from './contact/contact.component';
import { CategoriesComponent } from './categories/categories.component';
import { ProductsComponent } from './products/products.component';
import { ProductdetailsComponent } from './productdetails/productdetails.component';
import { OrderformComponent } from './orderform/orderform.component';

const routes: Routes = [{
	path:"",
	component:MaincontentComponent
},
{
	path:"categories",
	component:CategoriesComponent
},
{
	path:"categories/:id",
	component:CategoriesComponent
},
{
	path:"products",
	component:ProductsComponent
},
{
	path:"products/:id",
	component:ProductsComponent
},
{
	path:"product-detail",
	component:ProductdetailsComponent
},
{
	path:"product-detail/:id",
	component:ProductdetailsComponent
},
{
	path:"about",
	component:AboutComponent
},
{
	path:"contact",
	component:ContactComponent
},
{
	path:"order",
	component:OrderformComponent
},
{
	path:"order/:id",
	component:OrderformComponent
}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
